export const types = Object.freeze({
  SET_STEP_ONE_DATA: "SET_STEP_ONE_DATA",
  CLEAR_STEP_ONE_DATA: "CLEAR_STEP_ONE_DATA",
  SET_STEP_TWO_DATA: "SET_STEP_TWO_DATA",
  SHOW_STEP_THREE: "SHOW_STEP_THREE",
  CLEAR_STEP_TWO_DATA: "CLEAR_STEP_TWO_DATA",
  CLEAR_ALL: "CLEAR_ALL",
});
